module.exports = __webpack_public_path__ + "img/dp-gr-ly2.6e73476b.png";